import React from "react";

const OrderManagementList = React.lazy(() => import("src/pages/order_management/OrderManagementList"));

const order_management_route = [
    {
        path: "order-management-list",
        name: "Order Management List",
        element: OrderManagementList,
    },
];

export default order_management_route;